import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const ENDPOINT = `${BACKEND_URL}/api/contact-info`;

// Simple module-level cache + subscriber list so multiple components share one fetch.
let cache = null;
let inflight = null;
const subs = new Set();

const notify = (data) => {
    cache = data;
    subs.forEach((cb) => cb(data));
};

const fetchOnce = () => {
    if (cache) return Promise.resolve(cache);
    if (inflight) return inflight;
    inflight = axios
        .get(ENDPOINT, { timeout: 8000 })
        .then((res) => {
            notify(res.data);
            return res.data;
        })
        .catch(() => {
            notify(null);
            return null;
        })
        .finally(() => {
            inflight = null;
        });
    return inflight;
};

export const refreshSiteConfig = () => {
    cache = null;
    return fetchOnce();
};

export const useSiteConfig = () => {
    const [config, setConfig] = useState(cache);

    useEffect(() => {
        let mounted = true;
        const cb = (v) => {
            if (mounted) setConfig(v);
        };
        subs.add(cb);
        if (!cache) fetchOnce();
        else cb(cache);
        return () => {
            mounted = false;
            subs.delete(cb);
        };
    }, []);

    return config;
};
